import React from 'react';
import { H4 } from '../Typography/H4';
import styles from './Card.module.css';
import Skeleton from 'react-loading-skeleton';

export const Card = ({
  label,
  text,
  icon,
  isLoading = false,
}: {
  label: string;
  text?: string;
  icon: string;
  isLoading?: boolean;
}) => (
  <div className={styles.container}>
    <div className={styles.iconContainer}>{icon}</div>
    <div className={styles.dataContainer}>
      <p className={styles.label}>{label}</p>
      {isLoading ? <Skeleton /> : <H4 className={styles.text}>{text}</H4>}
    </div>
  </div>
);
